module.exports = __webpack_public_path__ + "static/media/whatsapp.4ae865e8.svg";